module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#detail1_1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC3']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "detail1_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['100']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput),
      expression: "descCodinput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid),
      expression: "descCodempid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-block"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES33UC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['60']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.title_o),
      expression: "detail.title_o"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "title_o",
      "name": "title_o",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.title_o)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "title_o", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['70']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.name_ot),
      expression: "detail.name_ot"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name_ot",
      "name": "name_ot",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.name_ot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "name_ot", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.lastname_ot),
      expression: "detail.lastname_ot"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastname_ot",
      "name": "lastname_ot",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.lastname_ot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "lastname_ot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['110']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.name_oe),
      expression: "detail.name_oe"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name_oe",
      "name": "name_oe",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.name_oe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "name_oe", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['120']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.lastname_oe),
      expression: "detail.lastname_oe"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastname_oe",
      "name": "lastname_oe",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.lastname_oe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "lastname_oe", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES33UC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['60']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.title_n),
      expression: "detail.title_n"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "title_n",
      "name": "title_n",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.title_n)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "title_n", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['70']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.name_nt),
      expression: "detail.name_nt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name_nt",
      "name": "name_nt",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.name_nt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "name_nt", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.lastname_nt),
      expression: "detail.lastname_nt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastname_nt",
      "name": "lastname_nt",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.lastname_nt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "lastname_nt", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['110']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.name_ne),
      expression: "detail.name_ne"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name_ne",
      "name": "name_ne",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.name_ne)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "name_ne", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['120']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.lastname_ne),
      expression: "detail.lastname_ne"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastname_ne",
      "name": "lastname_ne",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.lastname_ne)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "lastname_ne", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC3']['90']))]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "desnote",
      "name": "desnote",
      "maxlength": "600",
      "readonly": "readonly"
    }
  }, [_vm._v(_vm._s(_vm.detail.desnote) + "\n                    ")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.buttonLabels['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76b4eee7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres33u/detail1.vue
// module id = 3891
// module chunks = 1